// =======================
// ELECTRO CURSOR V1
// =======================

if(window.innerWidth>768){

const canvas=document.createElement("canvas");

canvas.className="electro-canvas";

document.body.appendChild(canvas);

const ctx=canvas.getContext("2d");

function resize(){

canvas.width=window.innerWidth;

canvas.height=window.innerHeight;

}

resize();

window.addEventListener("resize",resize);

let mouse={

x:0,

y:0

};

document.addEventListener("mousemove",e=>{

mouse.x=e.clientX;

mouse.y=e.clientY;

});

let particles=[];

document.addEventListener("mousemove",()=>{

particles.push({

x:mouse.x,

y:mouse.y,

life:30,

dx:(Math.random()-0.5)*5,

dy:(Math.random()-0.5)*5

});

});

function animate(){

ctx.clearRect(0,0,canvas.width,canvas.height);

particles.forEach((p,i)=>{

p.x+=p.dx;

p.y+=p.dy;

p.life--;

ctx.beginPath();

ctx.arc(p.x,p.y,2,0,Math.PI*2);

ctx.fillStyle="#00e5ff";

ctx.shadowBlur=20;

ctx.shadowColor="#00e5ff";

ctx.fill();

if(p.life<=0){

particles.splice(i,1);

}

});

requestAnimationFrame(animate);

}

animate();

}